module.exports = ReduxThunk;


//////////////////
// WEBPACK FOOTER
// external "ReduxThunk"
// module id = 40
// module chunks = 0